import { BusinessObjectBase } from '../../bo';
import { ModelBase, PropertyType } from './../../model';
import { ObservableCollection } from './../../observable';

import { Mutable } from '@skylab-shared/types';
import { Weaver } from '../../aop';
import { AttachedRule } from './attached-rule';
import { Rule, RuleDefinition, RuleResult, RulesEngine } from './rules-engine';
import { mergeDefinitions } from './utils/merge-definitions';

export class RequiredEngine<TBo extends BusinessObjectBase<TModel>, TModel extends ModelBase> extends RulesEngine<TBo, TModel, { required: boolean }> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    public get requiredProperties(): ObservableCollection<RuleResult> {
        return this.result;
    }

    public setAsRequired<TModel extends ModelBase>(property: PropertyType<TModel>): void {
        this.addRule([property], () => Promise.resolve(true));
    }

    protected override prepareAndAddRuleDefinition(
        triggeredBy: PropertyType<ModelBase>[],
        effectOn: PropertyType<ModelBase>[],
        rule: Rule,
        args: undefined
    ): void {
        effectOn.forEach(e => {
            const [target]: Mutable<RuleDefinition>[] = this.ruleDefinitions
                .filter(def => def.effectOn[0][0] === e[0] && def.effectOn[0][1] === e[1]);
            if (target) {
                const ruleDefinition = this.prepareRuleDefinition(triggeredBy, effectOn, rule, args);
                mergeDefinitions(target, ruleDefinition);
            } else {
                super.prepareAndAddRuleDefinition(triggeredBy, [e], rule, args);
            }
        });
    }

    protected override createAttachedRule(ruleDefinietion: RuleDefinition, triggeredByModel: ModelBase, effectOnModel: ModelBase): AttachedRule<{ required: boolean }> {
        return new AttachedRequiredRule(ruleDefinietion, this.bo, triggeredByModel, effectOnModel);
    }
}

export class AttachedRequiredRule extends AttachedRule<{ required: boolean; }> {
    protected override async validateRule(): Promise<{ required: boolean; }> {
        const ctx = { bo: this.bo, source: this.source, target: this.target };
        const isRequired = await this.ruleDefinition.rule.funcAsync(ctx);
        return {
            required: isRequired
        };
    }
}
